import React from 'react';
import { normalizePremiumFolderData } from '../../utils/normalizePremiumFolderData';
import HiddenDumbView from './Hidden';
import PremiumDumbView from './Premium';
import { useDeviationMatureFilter } from '../../utils/hooks/useDeviationMatureFilter';
export function useDumboCommon(props) {
    var _props_deviation;
    const { showBlocked } = useDeviationMatureFilter(props.deviation);
    if (!props.deviation) {
        return null;
    }
    if (showBlocked && !props.showMatureContent) {
        return /*#__PURE__*/ React.createElement(HiddenDumbView, props);
    }
    const { isPremiumLocked } = normalizePremiumFolderData((_props_deviation = props.deviation) === null || _props_deviation === void 0 ? void 0 : _props_deviation.premiumFolderData);
    if (isPremiumLocked) {
        return /*#__PURE__*/ React.createElement(PremiumDumbView, props);
    }
}
